import React from 'react';
import { SimpleBarChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildXYChartOptions, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = transformToGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const options = {
                    ...buildXYChartOptions(chart, { bottomMapsTo: 'group' }),
                    color: { scale: colorScale }
                };
                return renderChart(data, <SimpleBarChart options={options} data={data} />);
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
